var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      attrs: {
        title: _vm.$t("attachments.import_attach"),
        iconF7: "list_bullet",
      },
    },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-row",
            [
              _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                _c(
                  "label",
                  {
                    staticStyle: {
                      width: "100%",
                      "margin-bottom": "0px",
                      "margin-top": "-4px",
                    },
                  },
                  [
                    _c("div", { staticClass: "fileContainer" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("common.chse_file")) +
                          "\n            "
                      ),
                      _c("input", {
                        ref: "fileInput",
                        attrs: { type: "file", name: "file2", id: "file2" },
                        on: { change: _vm.onFileChange },
                      }),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.attachmentName,
                      expression: "attachmentName",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "text",
                    name: "filename",
                    placeholder: _vm.attachmentsImport_chseFile,
                    disabled: "",
                  },
                  domProps: { value: _vm.attachmentName },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.attachmentName = $event.target.value
                    },
                  },
                }),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c(
                    "form-write-group-label-input",
                    {
                      attrs: {
                        isMandatory: "",
                        inputLabel: _vm.$t("businessDocuments.document_type"),
                        inputType: "listeSelect",
                        mandatoryErrorIndicator: _vm.fileTypeSelectedError,
                      },
                    },
                    [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.fileTypeSelected,
                              expression: "fileTypeSelected",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { id: "sel2", readonly: "" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.fileTypeSelected = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v(
                              _vm._s(_vm.$t("businessDocuments.slct_doct_type"))
                            ),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.fileTypeList, function (fileType) {
                            return _c(
                              "option",
                              {
                                key: fileType.fileTypeValue,
                                domProps: { value: fileType.fileTypeValue },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t(fileType.fileTypeLabel)) +
                                    "\n            "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      inputLabel: _vm.$t("common.rfrnc"),
                      placeholderValue: _vm.attachmentsImport_Reference,
                    },
                    model: {
                      value: _vm.reference,
                      callback: function ($$v) {
                        _vm.reference = $$v
                      },
                      expression: "reference",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "footerButtons" },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "2", "offset-md": "9" } },
                [
                  _c(
                    "f7-button",
                    {
                      staticClass:
                        "milkyBlockBlack importAttachmentButton button-action",
                      on: { click: _vm.importAttachment },
                    },
                    [
                      _c("f7-icon", { attrs: { f7: "list_bullet" } }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("common.imprt")))]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }